/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-03-26 22:23:36
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-07-25 17:07:06
 * @FilePath: \合联\oms\src\utils\lodop.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

// ====页面动态加载C-Lodop云打印必须的文件CLodopfuncs.js====

var head =
  document.head ||
  document.getElementsByTagName("head")[0] ||
  document.documentElement;

var oscript = document.createElement("script");

// 让本机的浏览器打印(更优先一点)：

oscript = document.createElement("script");

oscript.src = "http://localhost:8000/CLodopfuncs.js?priority=2";

head.insertBefore(oscript, head.firstChild);

// 加载双端口(8000和18000）避免其中某个端口被占用：

oscript = document.createElement("script");

oscript.src = "http://localhost:18000/CLodopfuncs.js?priority=1";

head.insertBefore(oscript, head.firstChild);

// 下载loadLodop

function loadLodop() {
  // 指向服务器文件的路径
  window.open(
    "https://tms.vnlin.com/static/tools/CLodop_Setup_for_Win32NT.exe"
  );
}

// ====获取LODOP对象的主过程：====

function getLodop(that) {
  var LODOP;
  try {
    LODOP = getCLodop();
    if (!LODOP && document.readyState !== "complete") {
      that.Alert(
        "C-lodop print control is not ready, please try again later!"
      );
      return;
    }
    LODOP.SET_LICENSES("", "300B181168F063B4626A778296739625282", "", "");
    return LODOP;
  } catch (err) {
    let text = { 'zh-CN': '打印功能需要安装Lodop插件,是否下载安装？', 'en-US': 'You have not installed the print control. Click OK to download the print control. After the installation is successful, you can refresh the page to print' }
    that.$Modal.confirm({
      title: 'TIPS',
      content: text[that.$i18n.locale],
      okText: that.$t('confirm'),
      cancelText: that.$t('cancel'),
      onOk() {
        loadLodop();
      }
    })

  }
}

export function printType() {
  var LODOP = getLodop(this);;
  if (!LODOP) return
  var iCount = LODOP.GET_PRINTER_COUNT();
  var printList = [{ label: this.$t('SystemDefault'), value: -1 }]
  Array(iCount).fill(1).forEach((t, i) => {
    var strPName = LODOP.GET_PRINTER_NAME(i);
    printList.push({
      value: i,
      label: strPName
    })
  })
  return printList
};

export default getLodop;
